import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

var config = {
  apiKey: "AIzaSyCGsGoCsIrYaZscXcH8AVfanYvmMsFbz54",
  authDomain: "tely-totem.firebaseapp.com",
  projectId: "tely-totem",
  storageBucket: "tely-totem.appspot.com",
  messagingSenderId: "1079453868204",
  appId: "1:1079453868204:web:024c47120f9c75bb8d3f09",
  measurementId: "G-FBF02GD34P"
}

export default firebase.initializeApp(config)
